module.exports = __webpack_public_path__ + "static/media/YM64_5.1fa9705f.jpg";